import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable, { ocFormatRequest } from './TicketDetailTable.jsx';
import './TicketReport.css';

class OCAgentPerChannelTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedGroup: null,
      selectedColumnType: null,
      selectedAgentName: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_qc_agent_performance_channel();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      this.get_filtered_qc_agent_performance_channel();
    } else if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.team_member !== this.props.team_member
    ) {
      this.get_filtered_qc_agent_performance_channel();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#ocChannelTable')) {
      $('#ocChannelTable').DataTable().clear().destroy();
    }
  }

  get_filtered_qc_agent_performance_channel() {
    var that = this;
    if (!this.props.shouldLoadData) return;

    const filters = {
      start_date: this.props.yestSend,
      end_date: this.props.todSend,
      download: 0,
      report_code: 'oc_agent_performance_channel_wise',
      group_by: 'channel',
      report_type: 'oc-agent-performance',
      merchant: this.props.merchantID || [],
      store: this.props.storeID || [],
      issue_category: this.props.cf_issue_sub_category || [],
      city: this.props.city || [],
      channel: this.props.channel || [],
      product: this.props.product || [],
      team: this.props.team || [],
      team_member: this.props.team_member || [],
    };

    isApiResponse(false);

    if ($.fn.DataTable.isDataTable('#ocChannelTable')) {
      $('#ocChannelTable').DataTable().clear().destroy();
    }

    $('#ocChannelTable').DataTable({
      order: [],
      processing: true,
      serverSide: true,
      bDestroy: true,
      paging: true,
      pageLength: 5,
      bInfo: false,
      autoWidth: true,
      responsive: false,
      scrollX: true,
      searching: true,
      lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
      fixedColumns: { leftColumns: 1 },
      ajax: {
        url: config.get('API_URL') + '/ServiceReport/oc_agent_performance',
        type: 'POST',
        contentType: 'application/json',
        data: function (d) {
          return ocFormatRequest(d, filters);
        },
        dataSrc: function (json) {
          isApiResponse(true);
          that.setState({ isChange: false });
          return json.data;
        },
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', localStorage.usertoken);
        },
        error: function (data) {
          isApiResponse(true);
          alert('Failed to load data. Please try again');
          console.log('error', data);
        },
        complete: function (data) {
          isApiResponse(true);
        },
      },
      columns: [
        { data: 'Channel Name', width: '180px' },
        { data: 'Agent Name', width: '150px' },
        { data: 'No of Tickets Allocated', width: '120px' },
        { data: 'Within TAT - No Of Tickets Moved', width: '140px' },
        { data: 'Outside TAT - No Of Tickets Moved', width: '140px' },
        { data: '% of Tickets Moved Within TAT', width: '120px' },
        { data: 'Actual Work Hours Spent', width: '120px' },
        { data: 'Productivity', width: '100px' },
        { data: 'Cost/Ticket', width: '100px' }
      ],
      columnDefs: [
        {
          targets: 0,
          render: function (data) {
            const val = data == null ? '' : String(data);
            return "<div class='text-wrap width-150'>" + val + "</div>";
          }
        },
        {
          targets: 1,
          render: function (data) {
            const val = data == null ? '' : String(data);
            return "<div class='text-wrap width-80'>" + val + "</div>";
          }
        },
        {
          targets: [2, 3, 4],
          createdCell: function (td, cellData, rowData, row, col) {
            if (cellData > 0) {
              $(td).css({ cursor: 'pointer' });
              $(td).on('click', function () {
                that.handleCellClick(rowData, col);
              });
            }
          }
        },
        {
          targets: [5],
          render: function (data) {
            return data == null ? '0%' : data + '%';
          }
        }
      ]
    });
  }

  handleCellClick(rowData, colIndex) {
    const groupValue = rowData['Channel Name'];
    const agentName = rowData['Agent Name'];
    const columnMapping = {
      2: 'no_of_tickets_allocated',
      3: 'within_tat_allocated',
      4: 'outside_tat_allocated'
    };
    const colType = columnMapping[colIndex];
    if (colType) {
      this.setState({
        showDetails: true,
        selectedGroup: groupValue,
        selectedAgentName: agentName,
        selectedColumnType: colType
      });
    }
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedGroup: null,
      selectedColumnType: null,
      selectedAgentName: null
    });
  }

  render() {
    const { showDetails, selectedGroup, selectedColumnType } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
          <table id="ocChannelTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th className="merchant-header-default">Channel Name</th>
                <th className="merchant-header-default">Agent Name</th>
                <th className="merchant-header-default">No of Tickets Allocated</th>
                <th className="merchant-header-default">Within TAT - No Of Tickets Moved</th>
                <th className="merchant-header-default">Outside TAT - No Of Tickets Moved</th>
                <th className="merchant-header-default">% of Tickets Moved Within TAT</th>
                <th className="merchant-header-default">Actual Work Hours Spent</th>
                <th className="merchant-header-default">Productivity</th>
                <th className="merchant-header-default">Cost/Ticket</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
        {showDetails && (
          <TicketDetailTable
            key={`${selectedGroup}-${selectedColumnType}`}
            tableId="ocDetailsTable"
            apiUrl="/ServiceReport/oc_agent_performance_details"
            formatRequest={ocFormatRequest}
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              report_code: 'oc_agent_performance_channel_wise',
              group_by: 'channel',
              report_type: 'oc-agent-performance',
              group_value: selectedGroup,
              agent_name: this.state.selectedAgentName,
              column_type: selectedColumnType,
              merchant: this.props.merchantID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              team_member: this.props.team_member || [],
            }}
            title={`Ticket Details - ${selectedGroup}`}
            columnType={selectedColumnType}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'oc_agent_performance_channel_wise_details.csv.gz',
              url: '/service_reports/oc_agent_performance_details',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'oc_agent_performance_channel_wise_details',
                report_type: 'oc-agent-performance',
                group_by: 'channel',
                group_value: selectedGroup,
                agent_name: this.state.selectedAgentName,
                column_type: selectedColumnType,
                merchant: this.props.merchantID,
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                team_member: this.props.team_member,
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default OCAgentPerChannelTab;
